import InputInline from '../InputInline/InputInline'
import ArcadeRadioButton, { ArcadeRadioButtonProps } from '../RadioButton/ArcadeRadioButton'

export interface ArcadeRadioInlineProps extends ArcadeRadioButtonProps {
  label: string
  'aria-describedby'?: string
}

const ArcadeRadioInline = (props: ArcadeRadioInlineProps) => {
  return <InputInline InputInlineComponent={ArcadeRadioButton} {...props} />
}

export default ArcadeRadioInline
